__turbopack_context__.v({
  "active": "OffCanvasMenu-module__FTTPKq__active",
  "algSearch": "OffCanvasMenu-module__FTTPKq__algSearch",
  "canvas-overlay": "OffCanvasMenu-module__FTTPKq__canvas-overlay",
  "disable__submenu_dropdown": "OffCanvasMenu-module__FTTPKq__disable__submenu_dropdown",
  "dropdownArrow": "OffCanvasMenu-module__FTTPKq__dropdownArrow",
  "dropdownParent": "OffCanvasMenu-module__FTTPKq__dropdownParent",
  "dropdownParentOpen": "OffCanvasMenu-module__FTTPKq__dropdownParentOpen",
  "ebb-logo": "OffCanvasMenu-module__FTTPKq__ebb-logo",
  "enable__submenu_dropdown": "OffCanvasMenu-module__FTTPKq__enable__submenu_dropdown",
  "header-action-buttons-end": "OffCanvasMenu-module__FTTPKq__header-action-buttons-end",
  "header-button-container": "OffCanvasMenu-module__FTTPKq__header-button-container",
  "hiddenDropdown": "OffCanvasMenu-module__FTTPKq__hiddenDropdown",
  "hide__submenu": "OffCanvasMenu-module__FTTPKq__hide__submenu",
  "hover": "OffCanvasMenu-module__FTTPKq__hover",
  "menuIcon": "OffCanvasMenu-module__FTTPKq__menuIcon",
  "menuOpenWrapper": "OffCanvasMenu-module__FTTPKq__menuOpenWrapper",
  "nestedMenuItem": "OffCanvasMenu-module__FTTPKq__nestedMenuItem",
  "nestedMenuItemContainer": "OffCanvasMenu-module__FTTPKq__nestedMenuItemContainer",
  "nestedSubMenu": "OffCanvasMenu-module__FTTPKq__nestedSubMenu",
  "offcanvas-menu": "OffCanvasMenu-module__FTTPKq__offcanvas-menu",
  "offcanvasAccountIcon": "OffCanvasMenu-module__FTTPKq__offcanvasAccountIcon",
  "offcanvasAccountLink": "OffCanvasMenu-module__FTTPKq__offcanvasAccountLink",
  "offcanvasAccountSection": "OffCanvasMenu-module__FTTPKq__offcanvasAccountSection",
  "offcanvasLogoutButton": "OffCanvasMenu-module__FTTPKq__offcanvasLogoutButton",
  "search-icon": "OffCanvasMenu-module__FTTPKq__search-icon",
  "show__submenu": "OffCanvasMenu-module__FTTPKq__show__submenu",
  "signin": "OffCanvasMenu-module__FTTPKq__signin",
  "slideDown": "OffCanvasMenu-module__FTTPKq__slideDown",
  "slideUp": "OffCanvasMenu-module__FTTPKq__slideUp",
  "submenu": "OffCanvasMenu-module__FTTPKq__submenu",
  "submenuArrow": "OffCanvasMenu-module__FTTPKq__submenuArrow",
  "subscribe": "OffCanvasMenu-module__FTTPKq__subscribe",
  "threeLevelDivider": "OffCanvasMenu-module__FTTPKq__threeLevelDivider",
  "threeLevelFirstIcon": "OffCanvasMenu-module__FTTPKq__threeLevelFirstIcon",
  "threeLevelFirstItem": "OffCanvasMenu-module__FTTPKq__threeLevelFirstItem",
  "threeLevelFirstRow": "OffCanvasMenu-module__FTTPKq__threeLevelFirstRow",
  "threeLevelFirstText": "OffCanvasMenu-module__FTTPKq__threeLevelFirstText",
  "threeLevelSubmenu": "OffCanvasMenu-module__FTTPKq__threeLevelSubmenu",
  "threeLevelSubmenuItem": "OffCanvasMenu-module__FTTPKq__threeLevelSubmenuItem",
  "toggle-close": "OffCanvasMenu-module__FTTPKq__toggle-close",
});
